import { render, staticRenderFns } from "./ShopCasesCategoryTable.vue?vue&type=template&id=20fb1e52&scoped=true&"
import script from "./ShopCasesCategoryTable.vue?vue&type=script&lang=js&"
export * from "./ShopCasesCategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./ShopCasesCategoryTable.vue?vue&type=style&index=0&id=20fb1e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fb1e52",
  null
  
)

export default component.exports